import { render, staticRenderFns } from "./topicNews.vue?vue&type=template&id=a9682c42&scoped=true&"
import script from "./topicNews.vue?vue&type=script&lang=js&"
export * from "./topicNews.vue?vue&type=script&lang=js&"
import style0 from "./topicNews.vue?vue&type=style&index=0&id=a9682c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9682c42",
  null
  
)

export default component.exports